import { Box } from '@mui/material';

const containerStyle = {
    borderBottom: '1px solid #E5E5E5',
    padding: '10px 20px 10px 20px',
    gap: '10px',
    height: '37px',
};

const CustomMenuHeader = () => {
    return <Box style={containerStyle}>Filter</Box>;
};

export default CustomMenuHeader;
